/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Duplication of these fields are required to separate internal and external schema,
 * so that if external schema changes internal schema could remain the same.
 *
 * RECOVER_PASSWORD_FIELDS - internal
 *
 * RECOVER_PASSWORD_REQUEST_FIELDS - external
 */

export enum RECOVER_PASSWORD_FIELDS {
  PASSWORD = "newPassword",
  PASSWORD_REPEAT = "repeatedPassword",
}
export enum RECOVER_PASSWORD_REQUEST_FIELDS {
  PASSWORD = "newPassword",
  PASSWORD_REPEAT = "repeatedPassword",
}
